export const makeReferencePropertyItemID = (
  baseID: string,
  isSubject: boolean,
  isPairedSales: boolean,
  index: string,
) => {
  if (isPairedSales && !isSubject) {
    return `${baseID}_pair_${index}`;
  }

  return `${baseID}_${isSubject ? 'subject' : `comp_${index}`}`;
};
